// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:47 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class SignupServiceInterface {
  constructor() {
    this.service_id = 'signupservice-1_0';
  }

  // sendActivationEmail, Response: true
  // tenancy_id: int
  // user_id: string
  sendActivationEmail(tenancy_id, user_id, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SendActivationEmailRequest', { tenancyId: tenancy_id, userId: user_id }, success_callback);
  }

  /**
   * {email: String, password: String}
   */
  signupNewUser(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SignupNewUserAction', request, success_callback);
  }

  /**
   * {appId: String, loginToken: String}
   */
  startShortSignupSecondStep(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'StartShortSignupSecondStepAction', request, success_callback);
  }

  /**
   * {}
   */
  getCountryList(success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CountryListRequest', {}, success_callback);
  }

  /**
   * {url: String}
   */
  validateUniqueTenancyURL(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ValidateUniqueTenancyURLRequest', request, success_callback);
  }

  /**
   * {
   *   appId: String,
   *   firstName: Optional<String>
   *   lastName: Optional<String>
   *   isEducation: Boolean
   *   jobTitle: Optional<String>
   *   phone: String
   *   countryCode: String
   *   name: String
   *   url: String
   *   token: String
   *   invitationId: Optional<String>
   * }
   */
  finalizeSignupSecondStep(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'FinalizeSignupSecondStepAction', request, success_callback);
  }

  /**
   * {
   *   firstName: Optional<String>
   *   lastName: Optional<String>
   *   loginToken: String,
   *   tenancyId: Integer,
   * }
   */
  completeProfileAndRequestAccess(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'CompleteProfileAndRequestAccessAction', request, callback);
  }

  /**
   * {
   *   isEducation: boolean,
   *   countryCode: String,
   *   name: String,
   *   url: String,
   * } 
   */
  internalSignup(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'InternalSignupAction', request, callback);
  }

  getInternalSignupInfo(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'InternalSignupInfoRequest', request, callback);
  }

  getSignupRegion(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'SignupRegionRequest', request, callback);
  }
}

export const signupService = new SignupServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/signupservice.js
// module id = dDVJ
// module chunks = 1 2 4